import Vue from 'vue';
import VueI18n from 'vue-i18n';
import BootstrapVue from 'bootstrap-vue';

import App from './App.vue';
import router from './router';
import store from './store';
import axiosInstance from './api';

import ru from './locale/ru.json';
import en from './locale/en.json';
import cn from './locale/cn.json';

// const cn_ru = join(cn, ru);

import './styles/index.scss';
import 'devextreme/dist/css/dx.common.css';
import './styles/DevExtremeTheme/dx.material.custom-scheme-blue (2).css';
import './styles/iconsfont.scss';

function join(primary, secondary) {
  const result = {};
  for (const property in primary) {
    if (primary.hasOwnProperty(property)) {
      if (typeof primary[property] === 'object') {
        result[property] = join(primary[property], secondary[property]);
      } else {
        result[property] = `${primary[property]} / ${secondary[property]}`;
      }
    }
  }
  return result;
}

function isArray(o) {
  return o instanceof Array;
}

//const cn_ru = join(cn, ru);


// import './utils/bootstrap.js';


Vue.use(VueI18n);
Vue.use(BootstrapVue);

Vue.filter('currency', value => Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(value));

// eslint-disable-next-line camelcase
const formatter_date_only = new Intl.DateTimeFormat('ru');
const formatter = new Intl.DateTimeFormat('ru', {
  hour: 'numeric',
  minute: 'numeric',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});


Vue.filter('parseDate', date => {
  if (!date) return '';
  return formatter.format(new Date(date));
});

Vue.filter('parseDateOnly', date => {
  if (!date) return '';
  return formatter_date_only.format(new Date(date));
});

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'ru',
  messages: { ru, en, cn },
  fallbackLocale: 'en',
  formatFallbackMessages: true,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});

Vue.prototype.$http = axiosInstance;
Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

export { app, i18n };
